import { render, staticRenderFns } from "./Gant.vue?vue&type=template&id=031c585d&scoped=true&"
import script from "./Gant.vue?vue&type=script&lang=ts&"
export * from "./Gant.vue?vue&type=script&lang=ts&"
import style0 from "./Gant.vue?vue&type=style&index=0&id=031c585d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031c585d",
  null
  
)

export default component.exports